import e from"./palette.js";var r={dotColors:[e.brand.red,e.brand.yellow,e.brand.green,e.brand.purple,e.brand.blue],sizes:{S:{size:5,sidesMargin:2,jumpDistance:8},M:{size:12,sidesMargin:4,jumpDistance:15}}};export{r as default};
